var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
const BreakoutRoomUsers = ({ users }) => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    return (_jsx("div", { className: "", children: users.map((user) => {
            return (_jsxs("p", { className: "inline-block pr-2 mr-2 border-r border-solid border-black leading-4 last:border-none last:mr-0 last:pr-0", children: [user.name, " (", user.joined
                        ? t('breakout-room.user-joined')
                        : t('breakout-room.not-joined'), ")"] }, user.id));
        }) }));
};
_react_refresh_temp_1 = BreakoutRoomUsers;
$RefreshReg$(_react_refresh_temp_1, "BreakoutRoomUsers");
_react_refresh_temp_2(BreakoutRoomUsers, "zlIdU9EjM2llFt74AbE2KsUJXyM=", false, () => [useTranslation]);
export default BreakoutRoomUsers;
